//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../axios/axios.js'
import { convertConfiguredTime } from '../../../components/helpers.js'
import CardSeparator from '../../../components/Card/CardSeparator.vue'
import Comments from '../../../components/Comments/Comments.vue'

import VehicleProvisionRequestAgreed from './VehicleProvisionRequestAgreed.vue'
import VehicleProvisionBrigades from './VehicleProvisionBrigades/VehicleProvisionBrigades.vue'
import VehicleProvisionBrigadesQueue from './VehicleProvisionBrigades/VehicleProvisionBrigadesQueue.vue'
import VehicleProvisionRequestReport from './VehicleProvisionRequestReport.vue'
import VehicleProvisionReportStatistics from './VehicleProvisionReportStatistics.vue'
import VehicleProvisionCostDetails from './VehicleProvisionCostDetails.vue'
import VehicleProvisionDepartureReports from './VehicleProvisionDepartureReports.vue'
import VehicleProvisionRoutePointsList from './VehicleProvisionRoutePointsList.vue'

export default {
  components: {
    CardSeparator,
    Comments,
    VehicleProvisionRequestReport,
    VehicleProvisionReportStatistics,
    VehicleProvisionCostDetails,
    VehicleProvisionDepartureReports,
    VehicleProvisionRoutePointsList,
    VehicleProvisionBrigades,
    VehicleProvisionRequestAgreed,
    VehicleProvisionBrigadesQueue
  },
  props: {
    vehicleProvision: {
      type: Object,
      default: () => {
        return {}
      }
    },
    bp: {
      type: Object,
      default: () => {
        return {}
      }
    },
    request: {
      type: Object,
      default: () => {
        return {}
      }
    },
    report: {
      type: Object,
      default: null
    },
    requestProperties: {
      type: Object,
      default: () => {
        return {}
      }
    },
    requestForm: {
      type: Object,
      default: () => {
        return {}
      }
    },
    mobile: {
      type: Boolean,
      default: false
    },
    isCreate: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      openedBrigades: this.$d_hasOperation('vehicleProvisionManagement') || this.$d_hasOperation('vehicleProvisionCreation')
    }
  },
  computed: {
    managementAllowedOnlyToCoordinator: {
      get: function () {
        return !this.request.managementAllowedToOwner
      },
      set: function (val) {
        this.request.managementAllowedToOwner = !val
      }
    },
    assignedBrigade: function () {
      if (this.request && this.request.brigades) {
        return this.request.brigades.find(b => b.assigned) || null
      }
      return null
    },
    interval: function () {
      let start = this.request.serviceTimeAgreed || null
      let end = null
      if (start) {
        end = start + (this.request.maxServiceDuration || 86400000)
      } else if (this.request.serviceTimeRequired && this.request.serviceEndTimeRequired) {
        start = this.request.serviceTimeRequired
        end = this.request.serviceEndTimeRequired
      }
      return { start: start, end: end }
    },
    brigadeAssignmentAllowedToBrigadeReadonly: function () {
      return this.requestProperties.brigadeAssignmentAllowedToBrigade.readonly || !this.request.vehicleTransferAllowedToBrigade
    }
  },
  watch: {
    interval: {
      handler: function () {
        this.$nextTick(() => {
          if (this.interval.start && this.interval.end) {
            if (this.$refs.brigades) {
              this.$refs.brigades.validate()
            }
          }
        })
      },
      deep: true,
      immediate: true
    },
    managementAllowedOnlyToCoordinator: {
      handler: function (val) {
        if (val) {
          this.request.managementAllowedToAllParticipants = false

          if (!this.$d_hasOperation('vehicleProvisionCoordination')) {
            this.requestProperties.managementAllowedToAllParticipants.readonly = true
          }
        } else {
          this.requestProperties.managementAllowedToAllParticipants.readonly = false
        }
      },
      immediate: true
    },
    'request.managementAllowedToAllParticipants': {
      handler: function (val) {
        if (val) {
          if (this.$d_hasOperation('vehicleProvisionCoordination')) {
            this.managementAllowedOnlyToCoordinator = false
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    convertTime: function (ms) {
      return convertConfiguredTime(ms, { year: false, month: true, date: true, hour: true, min: true, sec: false })
    },
    getClassBanner: function (key) {
      switch (key) {
        case 'info':
          return 'bg-primary'
        case 'warning':
          return 'bg-warning'
        case 'critical':
          return 'bg-negative'
      }
    },
    clearVehicle: function () {
      this.request.vehicle = null
    },
    validate: function (validFieldKeys) {
      if (this.$refs.requestAgreed) {
        this.$refs.requestAgreed.validateFields(validFieldKeys)
      }
      if (this.$refs.reportStatistics) {
        this.$refs.reportStatistics.validateFields(validFieldKeys)
      }
      if (this.$refs.costDetails) {
        this.$refs.costDetails.validateFields(validFieldKeys)
      }
      this.validateFields(validFieldKeys)
    },
    validateFields: function (validFieldKeys) {
      validFieldKeys.forEach(validFieldKey => {
        if (this.$refs[validFieldKey]) {
          const validateResult = this.$refs[validFieldKey].validate()

          if (!validateResult && validFieldKey === 'brigades') {
            this.openedBrigades = true
          }
        }
      })
    },
    getWorkAreas: function () {
      const params = new URLSearchParams()
      params.set('property', 'workAreas')

      return axiosGet({
        url: '/service/delta/vehicleProvision/propertyValues?' + params.toString(),
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения значений параметра workAreas'
      })
    },

    onChangeVehicleTransferAllowedToBrigade: function (value) {
      if (!value) {
        this.request.brigadeAssignmentAllowedToBrigade = false
      }

      // const brigadeAssignmentAllowedToBrigadeProperty = this.requestProperties.brigadeAssignmentAllowedToBrigade
      // if (!value) {
      //   brigadeAssignmentAllowedToBrigadeProperty.readonly = true
      // } else {
      //   brigadeAssignmentAllowedToBrigadeProperty.readonly = brigadeAssignmentAllowedToBrigadeProperty.accessProps.readonly
      // }
    }
  }
}

